module.exports = __webpack_public_path__ + "img/dot-done2-min.83f808e0.png";